module.exports = __webpack_public_path__ + "img/02-ball-2.715e54b1.svg";